<div class="contact-page">
  <header class="page-hero">
    <h1>Cuéntanos qué necesita tu empresa.</h1>
    <p class="hero-lead">
      Explícanos el punto de partida, el problema o la idea. No necesitas preparar una
      especificación técnica antes de escribirnos.
    </p>
  </header>

  <section class="contact-layout" aria-labelledby="form-title">
    <aside aria-labelledby="direct-contact-title">
      <h2 id="direct-contact-title">Elige el canal que te resulte más cómodo.</h2>
      <address>
        <a href="mailto:contacto@atsiestudio.com">
          <span>Email</span>
          contacto&#64;atsiestudio.com
        </a>
        <a href="tel:+34655340607">
          <span>Teléfono</span>
          655 340 607
        </a>
        <a href="https://wa.me/34655340607" target="_blank" rel="noopener noreferrer">
          <span>WhatsApp</span>
          <span class="contact-link-value">
            Escribir por WhatsApp
            <svg
              class="external-link-icon"
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M7 5h8v8M15 5 5 15" />
            </svg>
          </span>
        </a>
      </address>
      <p class="location">ATSIestudio · Segovia, España</p>
    </aside>

    <div class="form-panel">
      <div class="form-heading">
        <h2 id="form-title">Empecemos por lo esencial.</h2>
        <p>
          Revisaremos el contexto para responderte con los siguientes pasos. Enviar la solicitud no
          implica compromiso. Los campos marcados con * son obligatorios.
        </p>
      </div>

      @if (status() === 'success') {
        <div #successMessage class="status-message success-message" role="status" tabindex="-1">
          <h3>Mensaje enviado correctamente.</h3>
          <p>
            Gracias por contarnos tu proyecto. Hemos recibido la solicitud y el siguiente paso será
            responderte para aclarar el encaje y cualquier dato necesario.
          </p>
          <button type="button" (click)="status.set('idle')">Enviar otro mensaje</button>
        </div>
      } @else {
        <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
          <div class="form-section-heading">
            <span>1</span>
            <div>
              <h3>Datos de contacto</h3>
              <p>Lo necesario para poder responderte.</p>
            </div>
          </div>
          <div class="field-row">
            <div class="field">
              <label for="name">Nombre *</label>
              <input
                id="name"
                type="text"
                formControlName="name"
                autocomplete="name"
                maxlength="100"
                aria-describedby="name-error"
                [attr.aria-invalid]="form.controls.name.touched && form.controls.name.invalid"
              />
              @if (form.controls.name.touched && form.controls.name.invalid) {
                <p id="name-error" class="field-error">Indica tu nombre.</p>
              }
            </div>
            <div class="field">
              <label for="email">Email *</label>
              <input
                id="email"
                type="email"
                formControlName="email"
                autocomplete="email"
                maxlength="254"
                aria-describedby="email-error"
                [attr.aria-invalid]="form.controls.email.touched && form.controls.email.invalid"
              />
              @if (form.controls.email.touched && form.controls.email.invalid) {
                <p id="email-error" class="field-error">Introduce un email válido.</p>
              }
            </div>
          </div>

          <div class="field-row">
            <div class="field">
              <label for="phone">Teléfono <span>(opcional)</span></label>
              <input
                id="phone"
                type="tel"
                formControlName="phone"
                autocomplete="tel"
                inputmode="tel"
                maxlength="30"
                aria-describedby="phone-error"
                [attr.aria-invalid]="form.controls.phone.touched && form.controls.phone.invalid"
              />
              @if (form.controls.phone.touched && form.controls.phone.invalid) {
                <p id="phone-error" class="field-error">Introduce un teléfono válido.</p>
              }
            </div>
            <div class="field">
              <label for="company">Empresa <span>(opcional)</span></label>
              <input
                id="company"
                type="text"
                formControlName="company"
                autocomplete="organization"
                maxlength="120"
              />
            </div>
          </div>

          <div class="form-section-heading">
            <span>2</span>
            <div>
              <h3>Contexto del proyecto</h3>
              <p>Una orientación inicial; concretaremos el alcance contigo.</p>
            </div>
          </div>

          <div class="field">
            <label for="project-type">Tipo de proyecto *</label>
            <select
              id="project-type"
              formControlName="projectType"
              aria-describedby="project-type-error"
              [attr.aria-invalid]="
                form.controls.projectType.touched && form.controls.projectType.invalid
              "
            >
              <option value="">Selecciona una opción</option>
              <option value="web">Desarrollo web</option>
              <option value="custom">Desarrollo personalizado</option>
              <option value="maintenance">Mantenimiento web</option>
              <option value="hosting">Hosting y dominios</option>
              <option value="other">Otro o no estoy seguro</option>
            </select>
            @if (form.controls.projectType.touched && form.controls.projectType.invalid) {
              <p id="project-type-error" class="field-error">Selecciona una opción.</p>
            }
          </div>

          <div class="field">
            <label for="budget">Presupuesto aproximado *</label>
            <select
              id="budget"
              formControlName="budget"
              aria-describedby="budget-help budget-error"
              [attr.aria-invalid]="form.controls.budget.touched && form.controls.budget.invalid"
            >
              <option value="">Selecciona un rango</option>
              <option value="690-1290">De 690 € a 1.290 €</option>
              <option value="1290-2490">De 1.290 € a 2.490 €</option>
              <option value="2490-5000">De 2.490 € a 5.000 €</option>
              <option value="more-than-5000">Más de 5.000 €</option>
              <option value="not-defined">Aún no lo tengo definido</option>
            </select>
            <p id="budget-help" class="field-help">Importes orientativos, sin IVA.</p>
            @if (form.controls.budget.touched && form.controls.budget.invalid) {
              <p id="budget-error" class="field-error">Selecciona un rango de presupuesto.</p>
            }
          </div>

          <div class="field">
            <label for="message">Cuéntanos qué necesitas *</label>
            <textarea
              id="message"
              formControlName="message"
              rows="7"
              minlength="20"
              maxlength="3000"
              aria-describedby="message-help message-error"
              [attr.aria-invalid]="form.controls.message.touched && form.controls.message.invalid"
            ></textarea>
            <div id="message-help" class="field-help">
              <span>Incluye contexto, objetivo y cualquier condicionante relevante.</span>
              <span>{{ form.controls.message.value.length }}/3000</span>
            </div>
            @if (form.controls.message.touched && form.controls.message.invalid) {
              <p id="message-error" class="field-error">Escribe al menos 20 caracteres.</p>
            }
          </div>

          <div class="honeypot" aria-hidden="true">
            <label for="website">No rellenar este campo</label>
            <input
              id="website"
              type="text"
              formControlName="website"
              tabindex="-1"
              autocomplete="off"
            />
          </div>

          <div class="privacy-field">
            <input
              id="privacy"
              type="checkbox"
              formControlName="privacyAccepted"
              aria-describedby="privacy-error"
              [attr.aria-invalid]="
                form.controls.privacyAccepted.touched && form.controls.privacyAccepted.invalid
              "
            />
            <label for="privacy">
              He leído la <a routerLink="/privacidad">política de privacidad</a> y acepto que mis
              datos se utilicen para responder a esta solicitud. *
            </label>
          </div>
          @if (form.controls.privacyAccepted.touched && form.controls.privacyAccepted.invalid) {
            <p id="privacy-error" class="field-error">
              Debes aceptar la política para enviar el formulario.
            </p>
          }

          <app-turnstile (tokenChange)="updateTurnstileToken($event)" />

          @if (submitError()) {
            <p class="submit-error" role="alert">{{ submitError() }}</p>
          }

          <p class="submit-assurance">
            Revisaremos la solicitud antes de proponer ningún trabajo o coste.
          </p>
          <button class="submit-button" type="submit" [disabled]="status() === 'submitting'">
            @if (status() === 'submitting') {
              Enviando…
            } @else {
              Enviar solicitud
            }
          </button>
        </form>
      }
    </div>
  </section>
</div>
